/**
 * Trust Badge Slider Module
 * @module trust-badge
 * @description Creates and manages a slideshow of trust badges/logos with customizable settings
 */
(function () {
  /**
   * Initializes and manages the trust badge slideshow functionality
   * @function logoSlideshow
   * @private
   */
  const logoSlideshow = () => {
    $('.trust-badge-section').each(function () {
      if ($(this).hasClass('slider_started')) {
        return '';
      }
      $(this).addClass('slider_started');
      const id = $(this).attr('id');
      const box = $(this).find('.trust-badge');
      const autoplay = box.data('autoplay');
      const stopAutoplay = box.data('stop-autoplay');
      const delay = box.data('delay') * 1000;
      const template = box.data('template');

      let sectionClass = $(this)
        .attr('class')
        .search('shopify-section-group-header-group');

      if (sectionClass > 0 && template == 'no-index') {
        box.remove();
      } else {
        box.addClass('show');
      }

      if (autoplay) {
        autoplayParm = {
          autoplay: {
            delay: delay,
            pauseOnMouseEnter: stopAutoplay,
            disableOnInteraction: false,
          },
        };
      } else {
        autoplayParm = {};
      }
      let swiperParms = {
        parallax: true,
        slidesPerView: 1,
        speed: box.data('speed') * 1000,
        loop: true,
        navigation: {
          nextEl: `#${id} .swiper-button-next`,
          prevEl: `#${id} .swiper-button-prev`,
        },
        pagination: {
          el: `#${id} .swiper-pagination`,
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            autoplay: false,
          },
          1200: {
            slidesPerView: 5,
            autoplay: false,
          },
        },
        ...autoplayParm,
      };
      const swiper = new Swiper(`#${id} .trust-badge__swiper`, swiperParms);
      colorScheme(swiper);
      swiper.on('beforeTransitionStart', function () {
        colorScheme(this);
      });

      /**
       * Updates the color scheme of navigation elements based on the active slide
       * @function colorScheme
       * @private
       * @param {Object} context - The Swiper instance context
       */
      function colorScheme(context) {
        const activeIndex = context.activeIndex;
        const activeSlide = context.slides[activeIndex];
        const changeItems = [
          context.navigation.nextEl,
          context.navigation.prevEl,
          context.pagination.el,
        ];
        const colorScheme = $(activeSlide)
          .find('.trust-badge-slide')
          .data('color-scheme');
        changeItems.forEach((item) => {
          $(item)
            .removeClass('color-background-1')
            .removeClass('color-background-4')
            .addClass(colorScheme);
        });
      }
    });
  };

  // Initialize the trust badge slider when DOM is ready
  document.addEventListener('DOMContentLoaded', function () {
    logoSlideshow();
    document.addEventListener('shopify:section:load', function () {
      logoSlideshow();
    });
  });
})();
